var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import AbstractAuthenticatedService from '../../../model/service/abstract-authenticated-service';
import DeleteConditionTask from '../../task/mapping/condition/delete-condition-task';
import GetConditionTask from '../../task/mapping/condition/get-condition-task';
import GetConditionsTask from '../../task/mapping/condition/get-conditions-task';
import PostConditionTask from '../../task/mapping/condition/post-condition-task';
import PutConditionTask from '../../task/mapping/condition/put-condition-task';
export default class ConditionService extends AbstractAuthenticatedService {
    /**
     * Find conditions using search conditions
     * @param searchConditions
     * @returns
     */
    findConditions(searchConditions) {
        return __awaiter(this, void 0, void 0, function* () {
            const task = new GetConditionsTask();
            task.token = this.token;
            task.searchConditions = searchConditions;
            return this.runTask(task);
        });
    }
    /**
     * Load a single condition
     * @param id
     * @returns
     */
    loadCondition(id) {
        return __awaiter(this, void 0, void 0, function* () {
            const task = new GetConditionTask();
            task.token = this.token;
            task.id = id;
            return this.runTask(task);
        });
    }
    /**
     * Create a new condition
     *
     * @param condition
     * @returns
     */
    createCondition(condition) {
        return __awaiter(this, void 0, void 0, function* () {
            const task = new PostConditionTask();
            task.token = this.token;
            task.condition = condition;
            return this.runTask(task);
        });
    }
    /**
     * Update a condition
     *
     * @param condition
     * @returns
     */
    updateCondition(condition) {
        return __awaiter(this, void 0, void 0, function* () {
            const task = new PutConditionTask();
            task.token = this.token;
            task.condition = condition;
            return this.runTask(task);
        });
    }
    /**
     * Delete a condition
     *
     * @param id
     * @returns
     */
    deleteCondition(id) {
        return __awaiter(this, void 0, void 0, function* () {
            const task = new DeleteConditionTask();
            task.token = this.token;
            task.id = id;
            return this.runTask(task);
        });
    }
    /**
     * Return the types as an array
     */
    static get OPERATORS() {
        return [
            ConditionService.OPERATOR_EQUAL,
            ConditionService.OPERATOR_EQUAL_CI,
            ConditionService.OPERATOR_GREATER_THAN,
            ConditionService.OPERATOR_GREATER_THAN_OR_EQUAL,
            ConditionService.OPERATOR_LESS_THAN,
            ConditionService.OPERATOR_LESS_THAN_OR_EQUAL,
            ConditionService.OPERATOR_CONTAINS,
            ConditionService.OPERATOR_DOES_NOT_CONTAIN,
            ConditionService.OPERATOR_EMPTY,
            ConditionService.OPERATOR_NOT_EMPTY,
            ConditionService.OPERATOR_STARTS_WITH,
            ConditionService.OPERATOR_ENDS_WITH,
            ConditionService.OPERATOR_LONGER_THAN,
            ConditionService.OPERATOR_SHORTER_THAN,
        ];
    }
    /**
     * Return the operator options for a select
     *
     * TODO update to use translations if possible
     */
    static get OPERATOR_OPTIONS() {
        return [
            {
                text: 'Equal',
                value: ConditionService.OPERATOR_EQUAL,
            },
            {
                text: 'Equal (Ignore case)',
                value: ConditionService.OPERATOR_EQUAL_CI,
            },
            {
                text: 'Greater than',
                value: ConditionService.OPERATOR_GREATER_THAN,
            },
            {
                text: 'Greater than or equal',
                value: ConditionService.OPERATOR_GREATER_THAN_OR_EQUAL,
            },
            {
                text: 'Less than',
                value: ConditionService.OPERATOR_LESS_THAN,
            },
            {
                text: 'Less than or equal',
                value: ConditionService.OPERATOR_LESS_THAN_OR_EQUAL,
            },
            {
                text: 'Contains',
                value: ConditionService.OPERATOR_CONTAINS,
            },
            {
                text: 'Does not contain',
                value: ConditionService.OPERATOR_DOES_NOT_CONTAIN,
            },
            {
                text: 'Empty',
                value: ConditionService.OPERATOR_EMPTY,
            },
            {
                text: 'Not empty',
                value: ConditionService.OPERATOR_NOT_EMPTY,
            },
            {
                text: 'Starts with',
                value: ConditionService.OPERATOR_STARTS_WITH,
            },
            {
                text: 'Ends with',
                value: ConditionService.OPERATOR_ENDS_WITH,
            },
            {
                text: 'Longer than',
                value: ConditionService.OPERATOR_LONGER_THAN,
            },
            {
                text: 'Shorter than',
                value: ConditionService.OPERATOR_SHORTER_THAN,
            },
        ];
    }
    /**
     * Return an array of the operators that don't require a value
     */
    static get NO_VALUE_OPERATORS() {
        return [
            ConditionService.OPERATOR_EMPTY,
            ConditionService.OPERATOR_NOT_EMPTY,
        ];
    }
}
ConditionService.OPERATOR_EQUAL = 'equal';
ConditionService.OPERATOR_EQUAL_CI = 'equal_ci';
ConditionService.OPERATOR_GREATER_THAN = 'greater_than';
ConditionService.OPERATOR_GREATER_THAN_OR_EQUAL = 'greater_than_or_equal';
ConditionService.OPERATOR_LESS_THAN = 'less_than';
ConditionService.OPERATOR_LESS_THAN_OR_EQUAL = 'less_than_or_equal';
ConditionService.OPERATOR_CONTAINS = 'contains';
ConditionService.OPERATOR_DOES_NOT_CONTAIN = 'does_not_contain';
ConditionService.OPERATOR_EMPTY = 'empty';
ConditionService.OPERATOR_NOT_EMPTY = 'not_empty';
ConditionService.OPERATOR_STARTS_WITH = 'starts_with';
ConditionService.OPERATOR_ENDS_WITH = 'ends_with';
ConditionService.OPERATOR_LONGER_THAN = 'longer_than';
ConditionService.OPERATOR_SHORTER_THAN = 'shorter_than';
//# sourceMappingURL=condition-service.js.map